var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"senior-menu",class:{expanded: _vm.seniorMenuState.expanded,
 'slide-out': _vm.seniorMenuState.hide, 'hide': _vm.seniorMenuState.hide}},[_c('SeniorMenuList',{ref:"menuList",attrs:{"linkslist":_vm.linkslist}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }